var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgRemove = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "background",
    width: 32,
    height: 32,
    rx: 6,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3333 8C14.0362 8 13.6667 8.28431 13.6667 8.8V9.6H18.3333V8.8C18.3333 8.28431 17.9638 8 17.6667 8H14.3333ZM20.3333 9.6V8.8C20.3333 7.32747 19.2105 6 17.6667 6H14.3333C12.7895 6 11.6667 7.32747 11.6667 8.8V9.6H8.5C7.94772 9.6 7.5 10.0477 7.5 10.6C7.5 11.1523 7.94772 11.6 8.5 11.6H9.16667V23.2C9.16667 24.6725 10.2895 26 11.8333 26H20.1667C21.7105 26 22.8333 24.6725 22.8333 23.2V11.6H23.5C24.0523 11.6 24.5 11.1523 24.5 10.6C24.5 10.0477 24.0523 9.6 23.5 9.6H20.3333ZM11.1667 11.6V23.2C11.1667 23.7157 11.5362 24 11.8333 24H20.1667C20.4638 24 20.8333 23.7157 20.8333 23.2V11.6H11.1667ZM14.3333 14.1C14.8856 14.1 15.3333 14.5477 15.3333 15.1V20.5C15.3333 21.0523 14.8856 21.5 14.3333 21.5C13.781 21.5 13.3333 21.0523 13.3333 20.5V15.1C13.3333 14.5477 13.781 14.1 14.3333 14.1ZM17.6667 14.1C18.219 14.1 18.6667 14.5477 18.6667 15.1V20.5C18.6667 21.0523 18.219 21.5 17.6667 21.5C17.1144 21.5 16.6667 21.0523 16.6667 20.5V15.1C16.6667 14.5477 17.1144 14.1 17.6667 14.1Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRemove);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/remove.99bb367defd0474774758a336e2f102c.svg";